import React from 'react'

export default function CommunicationsPage() {
  return (
    <div>Communications</div>
  )
}
